import React, { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Container, Dimmer, Dropdown, Header, Icon, Image, Loader, Message, Segment, Step } from 'semantic-ui-react';
import './App.css';
import Complete from "./components/Complete";
import DataManager from "./components/DataManager";
import EmailResend from "./components/EmailResend";
import EmailValidation from "./components/EmailValidation";
import LegalTerms from "./components/LegalTerms";
import Password from "./components/Password";
import Photo from "./components/Photo";
import ReviewNameCustomization from './components/ReviewNameCustomization';
import ReviewPassport from "./components/ReviewPassport";
import UpdateComplete from './components/UpdateComplete';
import "./semantic/semantic.min.css";
import { parseJwt } from './Utils';

function App(props) {

    const getServerURL = () => {

        if (typeof props.serverurl !== "undefined")
        {
            return props.serverurl;
        }
        else
        {
            switch (window.location.hostname)
            {
                case "register.iatfadp.com":
                    return "https://admin.iatfadp.com";
                break;

                case "staging-register.iatfadp.com":
                case "staging-register-new.iatfadp.com":
                    return "https://staging-admin.iatfadp.com";
                break;

                case "localhost":
                case "local-iatf-register.plexuselearning.net":
                case "local-iatf-register-new.plexuselearning.net":
                default:
                    return "https://local-iatf-admin.plexuselearning.net:8085";
                    // return "https://local-plexus-admin.plexuselearning.net:8085";
                break;
            }
        }
// test_register@plexusintl.ca
// Confirmation Code: 3tkfnoh4q
// deepspace9
// eyJhbGciOiJSUzI1NiIsImV4cCI6MTc2NTg1NjI5MCwibmJmIjoxNzY1ODEzMDkwfQ.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.QuvBUXl_q6B0obLAV_gWRQ3omp94n_r4IEnqQcQByUd2tFV1Te7ummDqvdafjw2dTYICcrN8gXeXlrEfNPF8WlsNPfVnchvkjvL9jK-Flt50_DF0WdecJKJRhrOzxrpnhbl-l5ws9MuXXK9n2CYusm-1Lkolj4BJNOWgk0RyI_A

// test_register2@plexusintl.ca
// Confirmation Code: whbnfumak
// https://local-iatf-register-new.plexuselearning.net:8085/#e7a4d264-da92-11f0-a118-02420a000404/whbnfumak

// https://lingo.dev/en/react-router-i18n/detect-user-language

//eyJhbGciOiJSUzI1NiIsImV4cCI6MTc3MzIwMjQ3NCwibmJmIjoxNzczMTU5Mjc0fQ.eyJQYXJ0aWNpcGFudElEIjoiODg1ODRFRkItMTQwMi04NTkyLUY2OEEtM0M2OTYxMjI0NTc4IiwiZGV0YWlscyI6eyJQYXJ0aWNpcGFudElEIjoiODg1ODRFRkItMTQwMi04NTkyLUY2OEEtM0M2OTYxMjI0NTc4IiwiZmtQZXJzb25JRCI6IjU5NTg0RUZCLTAxOTctNjQxNy1GNjZGLTU3QjgwMDU3NTcyOSIsImZrUHJpbWFyeUF1ZGllbmNlSUQiOm51bGwsIlBhcnRpY2lwYW50U3RhdHVzIjoxLCJQYXJ0aWNpcGFudFNjaGVtZURldGFpbElEIjoiOTQ1ODRFRkItMDcxNC0zMjkyLUY2OEYtNEY3NDYyMDg3OTg1IiwiRXh0ZXJuYWxQYXJ0aWNpcGFudElEIjpudWxsLCJDZXJ0aWZpY2F0ZU51bWJlciI6bnVsbCwiQ2VydGlmaWNhdGVEYXRlIjpudWxsLCJFeHBpcnlEYXRlIjoiMjA5OS0xMi0zMSIsIlBhcnRpY2lwYW50U2NoZW1lU3RhdHVzIjoxLCJma0FjdGl2ZVBhcnRpY2lwYW50U2NoZW1lU2FuY3Rpb25JRCI6bnVsbCwiZmtFbGV2YXRlZFBhcnRpY2lwYW50U2NoZW1lQ2VydGlmaWNhdGVJRCI6bnVsbCwiRm9yY2VTY2hlbWVQcm9maWxlVXBkYXRlIjoxLCJQZXJzb25JRCI6IjU5NTg0RUZCLTAxOTctNjQxNy1GNjZGLTU3QjgwMDU3NTcyOSIsImZrU2VydmljZVN1YnNjcmlwdGlvbklEIjpudWxsLCJUaXRsZSI6bnVsbCwiRmlyc3ROYW1lIjoiQ2hpbmVzZSIsIkZpcnN0TmFtZUthbmppIjpudWxsLCJNaWRkbGVOYW1lcyI6bnVsbCwiTWlkZGxlTmFtZXNLYW5qaSI6bnVsbCwiTGFzdE5hbWUiOiJUZXN0IiwiTGFzdE5hbWVLYW5qaSI6bnVsbCwiU3VmZml4IjpudWxsLCJOYW1lTGFuZ3VhZ2VUYWciOm51bGwsIkRpc3BsYXlOYW1lIjpudWxsLCJDb21wYW55TmFtZSI6bnVsbCwiSG9tZUNvdW50cnkiOiJVUyIsIlByZWZlcnJlZExhbmd1YWdlVGFnIjoiZW4iLCJTeXN0ZW1MYW5ndWFnZVRhZyI6InpoLUhhbnMiLCJQZXJzb25TdGF0dXMiOjEsIklzQWN0aXZlQmFuIjowLCJVc2VySUQiOiI3MDU4NEVGQi0xNTkxLTE0ODgtRjY4Mi1CMTQ3NTI0MTM5MTUiLCJVc2VyU3RhdHVzIjoxLCJDb25maXJtYXRpb25Db2RlIjpudWxsLCJJc0NvbmZpcm1lZCI6MSwiRW1haWxBZGRyZXNzIjoiemgtaGFuc190ZXN0MkBwbGV4dXNpbnRsLmNhIiwiZmtTeXN0ZW1EaWFsZWN0SUQiOiI0MTkzOUFGNS0yM0E5LTQ1OWYtQkMwRC0zNDExQTg4N0E5ODEiLCJMYW5ndWFnZVRhZyI6InpoLUhhbnMiLCJGcmllbmRseU5hbWUiOiJTaW1wbGlmaWVkIENoaW5lc2UiLCJDb250ZW50RGlhbGVjdElEIjoiNjUzMDJiZGYtZDMxYS00MzJmLWIzNzktNjkyMzFmZmZkMDljIiwiZmtQZXJzb25hSUQiOm51bGwsIlBlcnNvbkFsaWFzZXMiOltdLCJSZXF1aXJlc1Bob3RvIjp0cnVlfX0.a_1bmnOBHlxuOMQI93hZhtxuEwny1BA2MWHlKgRe2Vw-RCRTE592ExwVqgoF0490P8IXsUX7jwAKdfm_APf15aY8SS-mMfTJhGkIMU6sAEjYJv8NqenB0ATamQVYKLpFqhsWmoBUqa5A9R6-z_OVPgtGWRxMvMYRIXkKE_Og940

    }
    const dataManager = new DataManager(getServerURL());

    const [terms, setTerms] = useState(null);
    const [step, setStep] = useState("validate");
    const [jwt, setJwt] = useState();
    const [requirePassword, setRequirePassword] = useState();
    const [requireNameUpdate, setRequireNameUpdate] = useState(true);
    const [requirePhotoUpdate, setRequirePhotoUpdate] = useState(true);
    const [agreed, setAgreed] = useState(false);
    const [croppedPhoto, setCroppedPhoto] = useState();
    const [loading, setLoading] = useState(true);
    const [participantDetails, setParticipantDetails] = useState(null);
    const [errorString, setError] = useState();
    const [systemDialectID, setSystemDialectID] = useState("289D312A-09AE-4df1-8F44-9D8C48F504FE");
    const [allowPrevious, setAllowPrevious] = useState(true);

    React.useEffect(() => {
        const _systemDialectID = sessionStorage.getItem("SystemDialectID");
        if (_systemDialectID) {
            sessionStorage.setItem("SystemDialectID", _systemDialectID);
        }

        let search = window.location.search;
        let params = new URLSearchParams(search);
        let jwt = params.get('jwt');

        async function check() {
            if (jwt) {
                const details = await updateJWT(jwt); // setJwt(jwt);

                sessionStorage.setItem("SystemDialectID", details.fkSystemDialectID);
                setSystemDialectID(details.fkSystemDialectID);
                await fetchTerms();

                setRequirePhotoUpdate(details.RequiresPhoto);

                // if (details.UserStatus === 1) {
                if (details.ForceSchemeProfileUpdate !== 1) {
                    setRequireNameUpdate(false);
                    setStep("photo");
                } else {
                    setStep("reviewPassport");
                }
                // if (details.UserStatus === 1) {
                //     setRequireNameUpdate(false);
                // }
                // setStep("updateInstructions");
                setAllowPrevious(false);
            } else if (window.location.hash) {
                await validateHash();
                await fetchTerms();
                setStep("terms");
            } else {
                await fetchTerms();
            }
        }

        check();
    }, []);

    const validateHash = async () => {
        console.log("Hash is " + window.location.hash);
        let hashString = window.location.hash.substring(1);
        console.log(hashString);

        let personID = window.location.hash.substring(1, window.location.hash.indexOf("/"));
        let confirmCode = window.location.hash.substring(window.location.hash.indexOf("/") + 1);

        if (typeof personID !== "undefined" && typeof confirmCode !== "undefined")
        {
            const response = await dataManager.validateAuto(personID, confirmCode)
            if (typeof response.data.success !== "undefined") {
                if (response.data.success === '0') {
                    setLoading(false);
                    setError(response.data.errorMessage);
                } else {
                    setRequirePassword(response.data.data.requirePassword);
                    const details = updateJWT(response.data.data.jwt); //props.setJwt(response.data.data.jwt);
                    sessionStorage.setItem("SystemDialectID", details.fkSystemDialectID);
                    setSystemDialectID(details.fkSystemDialectID);
                    //setStep("terms");
                }
            }
            else
            {
                setLoading(false);
                setError(response.data);
            }
        }
    };

    const fetchTerms = async () => {
        const response = await dataManager.fetchTerms("b9936018-d12b-11f0-8346-0ac9221eb135");
        if (typeof response.data !== "undefined" && typeof response.data.success !== "undefined") {
            if (response.data.success == 0) {
                // setError(response.data.errorMessage);
                console.log("bad");
            } else {
                setTerms(response.data.data);
                setLoading(false);
            }
        }
    };

    const parseJWt = (jwt) => {
        let tokenData = parseJwt(jwt);
        let details = JSON.parse(tokenData).details;

        // if no aliases check Kanji fields
        if (details.PersonAliases && details.PersonAliases.length == 0 && details.FirstNameKanji && details.LastNameKanji) {
            details.PersonAliases.push({
                "AliasType": "non-latin",
                "Surname": details.LastNameKanji,
                "GivenNames": details.FirstNameKanji,
                "Fullname": details.FirstNameKanji + " " + details.LastNameKanji,
                // "AliasLanguageTag": "ja",
                "IsPreferred": false
            });
        }


        // details.PersonStatus = 1;
        setParticipantDetails(details);
        // sessionStorage.setItem("SystemDialectID", details.fkSystemDialectID);
        return details;
    };

    const updateJWT = (jwt) => {
        const details = parseJWt(jwt);
        setJwt(jwt);
        return details;
    };

    const getTerm = (termID, defaultValue) => {
        if (terms?.hasOwnProperty(termID)) {
            return terms[termID];
        }
        return defaultValue;
    };

    const handleFlagClick = async (systemDialectID) => {
        sessionStorage.setItem("SystemDialectID", systemDialectID);
        setSystemDialectID(systemDialectID);
        setLoading(true);
        await fetchTerms();
    };

    const handleFlagClick2 = async (e, data) => {
        sessionStorage.setItem("SystemDialectID", data.value);
        setSystemDialectID(data.value);
        setLoading(true);
        await fetchTerms();
    };

    const languages = [
        {
            key: 'A22A92A3-45C6-4802-814A-DA9F39926B2E',
            text: 'Brazillian Portuguese',
            value: 'A22A92A3-45C6-4802-814A-DA9F39926B2E',
            image: <Image src='/images/flags/flag-pt.svg' style={{ height: '2em' }} />,
        },
        {
            key: '3873BE21-F9D6-4316-BAB8-2656F8EAC519',
            text: 'Castilian Spanish',
            value: '3873BE21-F9D6-4316-BAB8-2656F8EAC519',
            image: <Image src='/images/flags/flag-es.svg' style={{ height: '2em' }} />,
        },
        {
            key: 'BDE1A467-E219-4e7a-AE8C-136D77200F9D',
            text: 'Czech',
            value: 'BDE1A467-E219-4e7a-AE8C-136D77200F9D',
            image: <Image src='/images/flags/flag-cs.svg' style={{ height: '2em' }} />,
        },
        {
            key: '289D312A-09AE-4df1-8F44-9D8C48F504FE',
            text: 'English',
            value: '289D312A-09AE-4df1-8F44-9D8C48F504FE',
            image: <Image src='/images/flags/flag-en.svg' style={{ height: '2em' }} />,
        },
        {
            key: '18375C38-7994-47cc-9A55-796B71EBA0C9',
            text: 'French',
            value: '18375C38-7994-47cc-9A55-796B71EBA0C9',
            image: <Image src='/images/flags/flag-fr.svg' style={{ height: '2em' }} />,
        },
        {
            key: 'BA073C46-DBBF-4375-8F90-57F6085E5B83',
            text: 'German',
            value: 'BA073C46-DBBF-4375-8F90-57F6085E5B83',
            image: <Image src='/images/flags/flag-de.svg' style={{ height: '2em' }} />,
        },
        {
            key: 'A14410E8-EB9D-46b3-B045-012753F98B02',
            text: 'Italian',
            value: 'A14410E8-EB9D-46b3-B045-012753F98B02',
            image: <Image src='/images/flags/flag-it.svg' style={{ height: '2em' }} />,
        },
        {
            key: 'C77E5C36-4526-4e8c-8366-611D4602521A',
            text: 'Japanese',
            value: 'C77E5C36-4526-4e8c-8366-611D4602521A',
            image: <Image src='/images/flags/flag-ja.svg' style={{ height: '2em' }} />,
        },
        {
            key: '678A2569-2FAD-4ab3-8384-8658338CA412',
            text: 'Korean',
            value: '678A2569-2FAD-4ab3-8384-8658338CA412',
            image: <Image src='/images/flags/flag-ko.svg' style={{ height: '2em' }} />,
        },
        {
            key: '4685FB08-0532-4361-AA44-5EE8844EEB40',
            text: 'Latin Spanish',
            value: '4685FB08-0532-4361-AA44-5EE8844EEB40',
            image: <Image src='/images/flags/flag-es-419.png' style={{ height: '2em' }} />,
        },
        {
            key: 'AED2B9EA-70C2-4337-977B-18F634639C03',
            text: 'Polish',
            value: 'AED2B9EA-70C2-4337-977B-18F634639C03',
            image: <Image src='/images/flags/flag-pl.svg' style={{ height: '2em' }} />,
        },
        // {
        //     key: '611D7D3F-EE39-49e2-9B56-86036BF3EE72',
        //     text: 'Russian',
        //     value: '611D7D3F-EE39-49e2-9B56-86036BF3EE72',
        //     image: <Image src='/images/flags/flag-ru.svg' style={{ height: '2em' }} />,
        // },
        {
            key: '41939AF5-23A9-459f-BC0D-3411A887A981',
            text: 'Simplified Chinese',
            value: '41939AF5-23A9-459f-BC0D-3411A887A981',
            image: <Image src='/images/flags/flag-zh-Hans.svg' style={{ height: '2em' }} />,
        }
    ];

    return (
        <div className="App">
            <ErrorBoundary fallback={<div>An error occurred.  Please refresh the page to try again.</div>}>
                <Container className='topBanner' style={{display: 'flex', width: '100%', height: '8.5em', background: 'linear-gradient(to right, #2b49a8, #62d0f1, #ffffff)'}}>
                    <div style={{flexGrow: 1, flexShrink: 0, verticalAlign: 'middle', padding: '0.5em'}}><Image src='/images/iatf_logo_reserved.png' style={{display: 'inline', verticalAlign: 'middle'}} width={100} /><Header as="h2" style={{display: 'inline', color: 'white', padding: '0.5em', verticalAlign: 'middle'}}>ADP REGISTRATION</Header></div>
                    <div style={{ paddingTop: '0.5em', paddingRight: '0.5em', width: '275px' }}>
                        <Dropdown
                            selection
                            fluid
                            options={languages}
                            value={systemDialectID}
                            onChange={handleFlagClick2}
                        />
                    </div>

                </Container>

                <Dimmer active={loading} inverted>
                    <Loader active={loading} inverted></Loader>
                </Dimmer>

                {(!loading && !errorString) &&
                    <>
                        <Step.Group unstackable widths={5} style={{marginTop: '0px'}}>
                            {(!participantDetails || participantDetails.PersonStatus === 5) &&
                                <>
                                    <Step active={step === "validate" || step === "resend"}>
                                        <Icon name='mail' />
                                        <Step.Content>
                                            <Step.Title>{getTerm("813e8160-d12c-11f0-8346-0ac9221eb135", "Validate")}</Step.Title>
                                            <Step.Description>{getTerm("954224f0-d12c-11f0-8346-0ac9221eb135", "Confirm your email address")}</Step.Description>
                                        </Step.Content>
                                    </Step>

                                    <Step active={step === "terms"}>
                                        <Icon name='legal' />
                                        <Step.Content>
                                            <Step.Title>{getTerm("9cc074de-d12c-11f0-8346-0ac9221eb135", "Agree")}</Step.Title>
                                            <Step.Description>{getTerm("a57547a8-d12c-11f0-8346-0ac9221eb135", "Legal Terms and Conditions")}</Step.Description>
                                        </Step.Content>
                                    </Step>
                                </>
                            }

                            {requireNameUpdate &&
                                <Step active={step === "reviewPassport" || step === "reviewCustomization"}>
                                    <Icon name='info' />
                                    <Step.Content>
                                        <Step.Title>{getTerm("b93ece62-d479-11f0-9cd9-0ac9221eb135", "Review")}</Step.Title>
                                        <Step.Description>{getTerm("d53c2e8e-d479-11f0-9cd9-0ac9221eb135", "Personal Information Review")}</Step.Description>
                                    </Step.Content>
                                </Step>
                            }

                            {requirePhotoUpdate &&
                                <Step active={step === "photo"}>
                                    <Icon name='photo' />
                                    <Step.Content>
                                        <Step.Title>{getTerm("aae55b74-d12c-11f0-8346-0ac9221eb135", "Photo")}</Step.Title>
                                        <Step.Description>{getTerm("b7951f08-d12c-11f0-8346-0ac9221eb135", "Upload your photo")}</Step.Description>
                                    </Step.Content>
                                </Step>
                            }

                            {(!participantDetails || participantDetails.PersonStatus === 5) &&
                                <Step active={step === "password"}>
                                    <Icon name='key' />
                                    <Step.Content>
                                        <Step.Title>{getTerm("bbc8112a-d12c-11f0-8346-0ac9221eb135", "Password")}</Step.Title>
                                        <Step.Description>{getTerm("c08a3238-d12c-11f0-8346-0ac9221eb135", "Pick your personal password")}</Step.Description>
                                    </Step.Content>
                                </Step>
                            }
                        </Step.Group>

                        <Segment size='large' padded style={{maxWidth: '1200px', margin: '0 auto'}}>
                            {(step === "validate") &&
                                <EmailValidation setStep={setStep} setRequirePassword={setRequirePassword} setJwt={updateJWT} dataManager={dataManager} getTerm={getTerm} />
                            }
                            {(step === "resend") &&
                                <EmailResend setStep={setStep} dataManager={dataManager} getTerm={getTerm} />
                            }
                            {(step === "terms") &&
                                <LegalTerms setStep={setStep} dataManager={dataManager} getTerm={getTerm} agreed={agreed} setAgreed={setAgreed} />
                            }
                            {(step === "reviewPassport") &&
                                <ReviewPassport setStep={setStep} jwt={jwt} dataManager={dataManager} getTerm={getTerm} participantDetails={participantDetails} setParticipantDetails={setParticipantDetails} allowPrevious={allowPrevious} />
                            }
                            {(step === "reviewCustomization") &&
                                <ReviewNameCustomization setStep={setStep} jwt={jwt} dataManager={dataManager} getTerm={getTerm} participantDetails={participantDetails} setParticipantDetails={setParticipantDetails} requirePhotoUpdate={requirePhotoUpdate} />
                            }
                            {(step === "photo") &&
                                <Photo setStep={setStep} requirePassword={requirePassword} setCroppedPhoto={setCroppedPhoto} jwt={jwt} dataManager={dataManager} getTerm={getTerm} participantDetails={participantDetails} allowPrevious={allowPrevious}/>
                            }
                            {(step === "password") &&
                                <Password setStep={setStep} jwt={jwt} croppedPhoto={croppedPhoto} dataManager={dataManager} getTerm={getTerm} />
                            }
                            {(step === "complete") &&
                                <Complete getTerm={getTerm} />
                            }
                            {(step === "updateComplete") &&
                                <UpdateComplete getTerm={getTerm} />
                            }
                        </Segment>
                    </>
                }

                { (typeof errorString !== "undefined") &&
                    <Message error icon>
                        <Icon name='exclamation' />
                        <Message.Content>
                        <Message.Header>{getTerm("c2d4a314-d13d-11f0-8346-0ac9221eb135", "An error occurred")}</Message.Header>
                        {errorString}
                        </Message.Content>
                    </Message>
                }

            </ErrorBoundary>
        </div>
    );
}

export default App;
